import { OrderDraftField } from "@saleor/graphql";
import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

export const saveDraftUrl = "/save-draft";

export type SaveDraftListSort = Sort<OrderDraftField>;
export type SaveDraftListQueryParam = Pagination & SaveDraftListSort;

export const saveDraftListUrl = (params?: SaveDraftListQueryParam) =>
  saveDraftUrl + "?" + stringifyQs(params);
